import { StockOnHandItems } from '@/api/receive';
import { UIBox } from '@/components/ui/Box';
import { UIButtonWithIcon } from '@/components/ui/Button';
import { Typography } from '@/components/ui/Typography';
import { useSelector } from '@/hooks/useSelector';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '../style';

type RecapItemProps = {
  onClick: (id: string) => Promise<void> | void;
  lockingUser: string;
};

const RecapItem: React.FC<StockOnHandItems & RecapItemProps> = ({
  id,
  date,
  stockOnHandStatus,
  onClick,
  lockingUser,
}) => {
  const { t } = useTranslation();
  const user = useSelector(state => state.user);

  return (
    <S.ListItem
      //@ts-ignore
      button={stockOnHandStatus === 'ONGOING'}
    >
      <UIBox width="100%" alignItems="center">
        <S.CalendarIcon />
        <Typography>
          {date} - {t('lockedBy')}: {lockingUser}
        </Typography>
        {stockOnHandStatus === 'ONGOING' && (
          <S.Actions>
            <UIButtonWithIcon
              marginTop="0px"
              label={
                user.username === lockingUser
                  ? t('soha.kickoff.open')
                  : t('soha.kickoff.label')
              }
              endIcon={<S.Unlock />}
              onClick={(): Promise<void> | void => onClick(id || '')}
            />
          </S.Actions>
        )}
      </UIBox>
    </S.ListItem>
  );
};

export default RecapItem;
